export const TREE = 'tree';
export const BLOB = 'blob';
export const TREE_PATH_TYPE = 'repo';
export const BLOB_PATH_TYPE = 'repoblob';
